import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const LazyAppWrapper = React.lazy(() => import('./AppWrapper'));
const LazyPrintCheckpointPage = React.lazy(() => import('./components/PrintCheckpointPage'));
const LazyPrintBatchCheckpointsPage = React.lazy(() => import('./components/PrintBatchCheckpointsPage'));
const LazyPrintBatchTeamCardsPage = React.lazy(() => import('./components/PrintBatchTeamCardsPage'));
const LazyDashboardLiteWrapper = React.lazy(() => import('./DashboardLiteWrapper'));
const LazySuperAdminWrapper = React.lazy(() => import('./SuperAdminWrapper'));

// Suppress known benign Firestore channel errors
const originalError = console.error;
console.error = (...args) => {
  const errorStr = String(args[0] || '');
  // Suppress Firestore WebChannel errors (transient connection issues)
  if (errorStr.includes('channel') || 
      errorStr.includes('WebChannel') ||
      errorStr.includes('firestore.googleapis.com') ||
      errorStr.includes('Listen/channel')) {
    return;
  }
  originalError.apply(console, args);
};

// Suppress fetch errors in the Network tab for Firestore channels
const originalFetch = window.fetch;
window.fetch = async (...args) => {
  try {
    return await originalFetch.apply(window, args);
  } catch (error) {
    // Suppress Firestore channel fetch errors
    if (args[0]?.includes?.('firestore.googleapis.com') && 
        args[0]?.includes?.('Listen/channel')) {
      return Promise.reject(error);
    }
    throw error;
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));

const pathname = (window.location.pathname || '/').replace(/\/+$/, '') || '/';

// Check if we're on a print page
const isPrintPage = pathname === '/print-checkpoint';
const isBatchPrintPage = pathname === '/print-batch-checkpoints';
const isBatchTeamCardsPage = pathname === '/print-batch-team-cards';
const isDashboardLitePage =
  pathname === '/dashboard-lite' ||
  pathname.endsWith('/dashboard-lite') ||
  pathname.startsWith('/dashboard-lite/');
const isSuperAdminPage = pathname === '/superadmin';

root.render(
  <React.StrictMode>
    <React.Suspense
      fallback={
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          backgroundColor: '#000',
          color: '#666',
          fontSize: '12px',
          fontFamily: 'monospace'
        }}>
          Loading...
        </div>
      }
    >
      {isPrintPage ? <LazyPrintCheckpointPage /> :
       isBatchPrintPage ? <LazyPrintBatchCheckpointsPage /> :
       isBatchTeamCardsPage ? <LazyPrintBatchTeamCardsPage /> :
       isDashboardLitePage ? <LazyDashboardLiteWrapper /> :
       isSuperAdminPage ? <LazySuperAdminWrapper /> :
       <LazyAppWrapper />}
    </React.Suspense>
  </React.StrictMode>
);

// Register service worker for offline support
serviceWorkerRegistration.register();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
